import { formatChemicalCompoundNameAsUnicode } from "@omnia/shared/utils/format";
import { IParam, param } from "../omnia"
import { IFertiliserAnalysis, NutrientType } from "../types"

export class TargetNutrients {


    private targetNutrients: IParam[];

    constructor() {

        this.setupTargetNutrients();

    }

    private setupTargetNutrients() {

        var nutrients = param.NutrientType();

        this.targetNutrients = nutrients.map(n => {
            return {
                text: formatChemicalCompoundNameAsUnicode(n.text),
                value: n.value
            }
        });

    }

    public getTargetNutrients(analysis: IFertiliserAnalysis, enableLime: boolean): IParam[] {

        if (analysis) {

            var nutrients = [];

            if (analysis.N) {
                nutrients.push(NutrientType.N);
            }
            if (analysis.SO3) {
                nutrients.push(NutrientType.SO3);
            }
            if (analysis.P2O5) {
                nutrients.push(NutrientType.P2O5);
            }
            if (analysis.K2O) {
                nutrients.push(NutrientType.K2O);
            }
            if (analysis.MgO) {
                nutrients.push(NutrientType.MgO);
            }
            if (enableLime && analysis.NeutralisingValue) {
                nutrients.push(NutrientType.Lime);
            }

            if (nutrients.length > 0) {
                return this.targetNutrients.filter(t => nutrients.indexOf(t.value) !== -1);
            }
        }

        return this.targetNutrients;
    }

}
